import type { ContentPage } from "@/lib/content/types";

// CRM › Sales Enablement › Alert and Notification (leaf).
export const alertAndNotification: ContentPage = {
  slug: "sales-enablement/alert-and-notification",
  template: "hrmsFeature",
  seo: {
    title: "CRM Alerts & Notifications - Real-Time Sales Alerts | GetBiz CRM",
    description: "Stay on top of every deal with GetBiz CRM alerts and notifications. Real-time, rule-based alerts for hot leads, stalled deals and pending approvals.",
    keywords: ["crm alerts", "sales notifications", "real-time crm alerts", "sales reminders"],
    ogImage: "/assets/data/seoimages/alert-and-notification.webp",
  },
  leaf: {
    hero: {
      caption: "Alert and Notification",
      title: "Never Miss a Moment That Matters",
      description: "Smart, real-time alerts tell reps and managers exactly when to act — a hot lead, a stalled deal, an approval waiting.",
      h1: "caption",
    },
    split: {
      title: "Why Teams Choose Alert and Notification",
      bullets: [
        { title: "Rule-Based Alerts", description: "Trigger alerts on any event or condition." },
        { title: "Real-Time Delivery", description: "In-app, email and mobile notifications." },
        { title: "Stalled-Deal Nudges", description: "Catch deals before they go cold." },
        { title: "Approval Pings", description: "Notify approvers the moment action is needed." },
      ],
      image: "/assets/images/img/product/crm/alert-and-notification-lead-image.webp",
      imageAlt: "Alert and Notification — GetBiz CRM",
    },
    cardsHeading: {
      title: "Works With the Rest of Sales Enablement",
      description: "Alert and Notification connects to every other part of Sales Enablement in GetBiz CRM.",
    },
    cards: [
      { title: "Finance", href: "/crm-software/sales-enablement/finance/", description: "Manage quotes, invoices and payments alongside deals so revenue moves from closed-won to collected without gaps.", image: "/assets/images/img/product/crm/finance.webp", imageAlt: "GetBiz CRM finance" },
      { title: "Configure, Price, Quote (CPQ)", href: "/crm-software/sales-enablement/configure-price-quote/", description: "Configure products, apply the right pricing and generate professional quotes instantly.", image: "/assets/images/img/product/crm/configure-price-quote.webp", imageAlt: "GetBiz CRM configure, price, quote (cpq)" },
      { title: "Documents Library", href: "/crm-software/sales-enablement/documents-library/", description: "Store, share and track proposals, decks and contracts from a central library, right where your deals live.", image: "/assets/images/img/product/crm/documents-library.webp", imageAlt: "GetBiz CRM documents library" },
      { title: "Calendar", href: "/crm-software/sales-enablement/calendar/", description: "Sync calendars, share booking links and see all your meetings next to the deals and contacts they belong to.", image: "/assets/images/img/product/crm/calendar.webp", imageAlt: "GetBiz CRM calendar" },
    ],
    testimonials: {
      title: "Businesses across India love & trust GetBiz!",
      description: "See why teams choose GetBiz CRM to run their sales.",
    },
    bookDemoTitle: "See Alert and Notification in action.",
    relatedBlogs: "static",
    metaKey: "sales-enablement-alert-and-notification",
  },
  sections: [],
};
